import React, {useMemo} from 'react';

import {FilterInput} from 'src/components/input';
import {useGetWorkspacesDetails} from 'src/modules/profile/user/tabs/content/workspace/hooks/useGetWorkspacesDetails';
import {useUserWorkspaces} from 'src/modules/profile/user/tabs/content/workspace/hooks/useUserWorkspaces';
import {SCOPE_KEY} from 'src/modules/profile/user/tabs/content/workspace/util';
import {WorkspaceTable} from 'src/modules/profile/user/tabs/content/workspace/workspace-table';
import {WorkspaceGeneralInfo} from 'src/openapi/admin/models/WorkspaceGeneralInfo';

import {BoxLoading} from '@pb/kit-component-box-loading';
import {Group} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';
import Typography from '@pb/kit-component-typography';

import {CONTENT_SUBTAB_SCOPE, ContentTabs} from '../content-tabs';
import {container, panel} from '../content.module.styl';


type Props = {
    userId: number,
};

export const UserWorkspaces = ({userId}: Props) => {
    const {
        data,
        criteria,
        isFetching,
        setCriteria,
        setPage,
        setPageSize,
        total,
    } = useUserWorkspaces({scopeKey: SCOPE_KEY, userId});

    const {total: workspacesTotal} = useUserWorkspaces({scopeKey: CONTENT_SUBTAB_SCOPE, userId});
    const isNoCreatedWorkspaces = !workspacesTotal || workspacesTotal === 0;

    const workspaceIds = useMemo(() => data.map((space: WorkspaceGeneralInfo) => space.workspaceId), [data]);

    const {
        data: workspaceDetailsData,
        isLoading: isLoadingWorkspaceDetails,
    } = useGetWorkspacesDetails({
        userId,
        ids: workspaceIds,
    });

    return (
        <>
            <StickyElement id="sticky-element">
                <ContentTabs userId={userId} activeTab="workspaces"/>
                <Group direction="h" gap="xxl" className={panel}>
                    <Typography fontWeight="semi-bold" variant="heading-level-3">Workspaces</Typography>
                    <FilterInput
                        id="user-workspace-name-filter"
                        placeholder="Search for workspaces by name or description"
                        onChange={query => setCriteria({nameQuery: query})}
                        onClear={() => setCriteria({nameQuery: undefined})}
                        timeOut={1000}
                        disabled={isNoCreatedWorkspaces}
                        width={345}
                        value={criteria?.nameQuery || ''}
                    />
                </Group>
            </StickyElement>
            <BoxLoading loading={isFetching || isLoadingWorkspaceDetails}>
                <Group direction="v" className={container}>
                    <WorkspaceTable
                        data={data}
                        total={total}
                        setPage={setPage}
                        setPageSize={setPageSize}
                        criteria={criteria}
                        workspaceDetailsData={workspaceDetailsData}
                        userId={userId}
                        isNoCreatedWorkspaces={isNoCreatedWorkspaces}
                    />
                </Group>
            </BoxLoading>
        </>
    );
};
